export const OFFER_STATUSES = [
  'pending',
  'accepted',
  'declined',
  'canceled',
] as const;
